import { observer } from 'mobx-react';
import InputComponent from '../../../../component/InputComponent';
import { Col, Form, Row } from 'antd';
import { TourPackageCategoryRequest } from '../../../../request/AuthRequest';

const FormComponent = observer((props) => {
	const { handleChange, onFinish, id, form } = props;

	return (
		<Form
			id={id}
			layout="vertical"
			form={form}
			onFinish={onFinish}
			autoComplete="off"
		>
			<Row gutter={24}>
				<Col span={12}>
					<InputComponent
						required
						name="name"
						label="Category Name"
						placeholder="Enter Category Name"
						onChange={handleChange}
						rules={TourPackageCategoryRequest.name}
					/>
				</Col>
				<Col span={12}>
					<InputComponent
						required
						name="sortOrder"
						label="Sort Order"
						placeholder="Enter Sort Order"
						onChange={handleChange}
						rules={TourPackageCategoryRequest.sortOrder}
					/>
				</Col>
			</Row>
		</Form>
	);
});

export default FormComponent;
